<template>
  <main id="main">
    <div v-if="lesson.type !== 'exam'" class="header_page d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center gap-4">
        <img src="@/assets/imgs/share.svg" class="icon-size-3 cursor-pointer" alt="" @click="shareContent('lesson', lesson.title)">
        <svg 
          width="24" 
          height="24" 
          viewBox="0 0 24 24" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
          class="icon-size-3 cursor-pointer"
          @click="toggleBookmark"
        >
          <path 
            d="M17 3H7C5.9 3 5 3.9 5 5V21L12 18L19 21V5C19 3.9 18.1 3 17 3Z" 
            :fill="lesson.marked ? '#4A00E0' : 'none'"
            :stroke="lesson.marked ? '#4A00E0' : '#000000'"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <div class="d-flex align-items-center">
        <p id="title_header_page">{{ lesson.title || '...' }}</p>
        <img id="arrow_back_page" src="@/assets/imgs/back.svg" alt="" @click="$router.go(-1)">
      </div>
    </div>

    <div v-else class="header_page d-flex align-items-center justify-content-between">
      <div v-if="examTimerString && !showExamStartModal" class="d-flex align-items-center gap-2 bg_red rounded-pill px-3 py-2 shadow-sm">
          <span class="text_color_white bold font_small">زمان باقی مانده: {{ examTimerString }}</span>
      </div>
      <div v-else></div>

      <div class="d-flex align-items-center">
        <p id="title_header_page">{{ t('exam') }}</p>
        <img id="arrow_back_page" src="@/assets/imgs/back.svg" alt="" @click="$router.go(-1)">
      </div>
    </div>

    <div class="p-3">
      <div v-if="loading" class="text-center mt-5">
        <p>{{ t('loading') }}</p>
      </div>

      <div v-else>
        <div v-if="lesson.type !== 'exam'" style="height: 23rem" class="w-100">
          <video 
            v-if="lesson.video && lesson.type === 'video' && isMp4(lesson.video)"
            :src="lesson.video"
            class="rounded-5 w-100 h-100 bg-black"
            controls
          ></video>
          <iframe 
            v-else-if="lesson.video && lesson.type === 'video'" 
            :src="getEmbedUrl(lesson.video)" 
            class="rounded-5 w-100 h-100" 
            frameborder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
            allowfullscreen
          ></iframe>
          <img 
            v-else 
            class="rounded-5 w-100 h-100" 
            src="@/assets/imgs/NoPath%20-%20Copy%20(5).png" 
            alt=""
          >
        </div>

        <div style="min-height: 60dvh" class="bg_white rounded-5 p-3 mt-4 shadow_box position-relative">
          
          <div v-if="lesson.type !== 'exam'">
            <div style="height: 3rem" class="d-flex justify-content-between align-items-center mb-2">
              <div 
                class="d-flex align-items-center justify-content-center flex-wrap gap-1 py-3 cursor-pointer flex-grow-1"
                :class="{ 'border_bottom_theme': activeTab === 'info' }"
                @click="activeTab = 'info'"
              >
                <img :src="activeTab === 'info' ? require('@/assets/imgs/information (2).svg') : require('@/assets/imgs/information_gray.svg')" class="icon-size-3" alt="">
                <p :class="activeTab === 'info' ? 'text_color_theme bold' : 'text_color_gray'">{{ t('about_lesson') }}</p>
              </div>

              <div style="width: 1px" class="h-100 bg_gray"></div>

              <div 
                class="d-flex align-items-center justify-content-center flex-wrap gap-1 py-3 cursor-pointer flex-grow-1"
                :class="{ 'border_bottom_theme': activeTab === 'qa' }"
                @click="activeTab = 'qa'"
              >
                <img :src="activeTab === 'qa' ? require('@/assets/imgs/blog_theme.svg') : require('@/assets/imgs/blog-_1_.svg')" class="icon-size-3" alt="">
                <p :class="activeTab === 'qa' ? 'text_color_theme bold' : 'text_color_gray'">{{ t('qa') }}</p>
              </div>

              <div style="width: 1px" class="h-100 bg_gray"></div>

              <div 
                class="d-flex align-items-center justify-content-center flex-wrap gap-1 py-3 cursor-pointer flex-grow-1"
                :class="{ 'border_bottom_theme': activeTab === 'exam' }"
                @click="activeTab = 'exam'"
              >
                <img :src="activeTab === 'exam' ? require('@/assets/imgs/clipboard_theme.svg') : require('@/assets/imgs/clipboard.svg')" class="icon-size-3" alt="">
                <p :class="activeTab === 'exam' ? 'text_color_theme bold' : 'text_color_gray'">{{ t('exam') }}</p>
              </div>
            </div>
            <hr class="mb-4">
          </div>

          <div v-if="lesson.type !== 'exam' && activeTab === 'info'">
            <div class="d-flex align-items-center justify-content-between p-3">
              <div class="d-flex align-items-center gap-2">
                <img src="@/assets/imgs/teaching.svg" class="icon-size-3" alt="">
                <p class="text_color_gray">{{ lesson.teacher_name }}</p>
              </div>
              <div class="d-flex align-items-center gap-2">
                <img src="@/assets/imgs/clock.svg" class="icon-size-2" alt="">
                <p class="text_color_gray">{{ lesson.time }}</p>
              </div>
            </div>

            <div v-if="lesson.pdf" class="w-100 mb-3 px-3">
               <button class="button w-100 d-flex justify-content-center align-items-center gap-2 py-3" @click="downloadPdf(lesson.pdf)">
                 <span>دانلود فایل مضمون (PDF)</span>
               </button>
            </div>

            <p class="bold mb-3 mt-3">{{ lesson.title }}</p>
            <p class="line_height_2">{{ lesson.about }}</p>
          </div>

          <div v-if="lesson.type !== 'exam' && activeTab === 'qa'">
             <div class="mb-6 pb-5">
                <div v-if="!lesson.questions_answers || lesson.questions_answers.length === 0" class="text-center text_color_gray mt-4">
                  {{ t('empty_list') }}
                </div>
                <div v-for="qa in lesson.questions_answers" :key="qa.id" class="bg_box_light_theme rounded-5 p-4 shadow-sm mb-3">
                  <div class="d-flex align-items-center gap-2">
                    <img src="@/assets/imgs/avatar.svg" class="icon-size-2" alt="">
                    <p class="text_color_theme bold">{{ qa.user_info }}</p>
                  </div>
                  <div class="d-flex align-items-start mt-3">
                    <p class="bold w-15">{{ t('your_question') }} :</p>
                    <p>{{ qa.question }}</p>
                  </div>
                  <div class="d-flex align-items-start mt-3" v-if="qa.teachers_answer">
                    <p class="bold w-30">{{ t('teacher') }} :</p>
                    <p>{{ qa.teachers_answer }}</p>
                  </div>
                </div>
             </div>

             <div class="position-absolute w-100 bottom-1 start-0 px-3">
                <div v-if="showQaInput" class="d-flex flex-column gap-2 bg_white p-3 rounded-4 shadow-lg mb-2 border">
                  <textarea v-model="newQuestion" class="w-100 p-2 rounded-3 border_gray" rows="3" :placeholder="t('write_question')"></textarea>
                  <div class="d-flex gap-2">
                    <button class="button w-50 py-2" @click="submitQuestion" :disabled="sendingQa">
                      {{ sendingQa ? t('send_otp') : t('send') }}
                    </button>
                    <button class="button w-50 py-2 bg_gray" @click="showQaInput = false">{{ t('cancel') }}</button>
                  </div>
                </div>
                <div v-else class="button w-40 mx-auto text-center cursor-pointer" @click="showQaInput = true">{{ t('ask_question') }}</div>
             </div>
          </div>

          <div v-if="lesson.type === 'exam' || activeTab === 'exam'">
            <div class="d-flex align-items-center justify-content-between p-3 mb-3">
              <div class="d-flex align-items-center gap-2">
                <img src="@/assets/imgs/teaching.svg" class="icon-size-3" alt="">
                <p class="text_color_gray">{{ lesson.exam_count }} {{ t('exam_count') }}</p>
              </div>
              <div class="d-flex align-items-center gap-2">
                <img src="@/assets/imgs/tick-_3_.svg" class="icon-size-2" alt="">
                <p class="text_color_gray">{{ t('score') }}: {{ lesson.exam_score }}</p>
              </div>
            </div>

            <div v-if="lesson.has_passed_exam" class="bg_light_theme rounded-pill p-2 text-center text_color_white mb-4">
               {{ t('passed_exam') }}
            </div>
            <div v-else-if="lesson.exam_count > 0 && lesson.type !== 'exam'" class="bg_red rounded-pill p-2 text-center text_color_white mb-4">
               {{ t('failed_exam') }}
            </div>

            <div v-if="!lesson.exam || lesson.exam.length === 0" class="text-center text_color_gray mt-4">
               {{ t('empty_list') }}
            </div>

            <div v-else class="mb-6 pb-5">
              <div v-for="(question, index) in lesson.exam" :key="question.id" class="bg_box_light_theme rounded-5 p-4 shadow-sm mb-3">
                <p class="bold mb-3">{{ index + 1 }}. {{ question.question }}</p>
                
                <div class="d-flex align-items-center mt-2 gap-2 cursor-pointer" @click="userAnswers[question.id] = 'a'">
                   <div class="radio_circle" :class="{ 'selected': userAnswers[question.id] === 'a' }"></div>
                   <p>{{ question.a }}</p>
                </div>
                
                <div class="d-flex align-items-center mt-3 gap-2 cursor-pointer" @click="userAnswers[question.id] = 'b'">
                   <div class="radio_circle" :class="{ 'selected': userAnswers[question.id] === 'b' }"></div>
                   <p>{{ question.b }}</p>
                </div>

                <div class="d-flex align-items-center mt-3 gap-2 cursor-pointer" @click="userAnswers[question.id] = 'c'">
                   <div class="radio_circle" :class="{ 'selected': userAnswers[question.id] === 'c' }"></div>
                   <p>{{ question.c }}</p>
                </div>

                <div class="d-flex align-items-center mt-3 gap-2 cursor-pointer" @click="userAnswers[question.id] = 'd'">
                   <div class="radio_circle" :class="{ 'selected': userAnswers[question.id] === 'd' }"></div>
                   <p>{{ question.d }}</p>
                </div>
              </div>

               <div class="d-flex justify-content-center mt-4">
                  <button class="button w-40" @click="submitExam" :disabled="submittingExam || isTimeUp" :style="isTimeUp ? 'opacity: 0.5' : ''">
                    {{ submittingExam ? t('send_otp') : t('finish_exam') }}
                  </button>
               </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div v-if="modal.show" class="modal_overlay">
      <div class="modal_content text-center">
        <div class="d-flex justify-content-center mb-3 position-relative">
           <div class="icon_circle" :class="modal.isSuccess ? 'bg_light_theme' : 'bg_red'">
             <img v-if="modal.isSuccess" src="@/assets/imgs/tick.svg" class="modal_img" alt="">
             <img v-else src="@/assets/imgs/close.svg" class="modal_img" alt="">
           </div>
        </div>
        <p class="bold font_large mb-3" :class="modal.isSuccess ? 'text_color_theme' : 'text_color_red'">
          {{ modal.title }}
        </p>
        <p class="font_normal mb-5 line_height_2 px-2">
          {{ modal.message }}
        </p>
        <button class="modal_btn" :class="!modal.isSuccess ? 'bg_red_btn' : ''" @click="closeModal">{{ t('understand') }}</button>
      </div>
    </div>

    <div v-if="showExamStartModal" class="modal_overlay">
      <div class="modal_content text-center">
        <p class="bold font_large mb-3 text_color_theme">توجه!</p>
        <p class="font_normal mb-5 line_height_2 px-2">
          این امتحان دارای زمان {{ examDuration }} دقیقه ای است و شما باید قبل از تمام شدن وقت امتحان را بدهید در غیر این صورت دکمه ارسال پاسخ غیرفعال میشود.
        </p>
        <div class="d-flex flex-column gap-3 w-100">
           <button class="modal_btn" @click="startExam">شروع</button>
           <button class="modal_btn bg_gray_btn" @click="cancelExam">لغو</button>
        </div>
      </div>
    </div>

  </main>
</template>

<script>
import apiClient, { createFormData } from '@/services/api'

export default {
  name: 'LessonDetailView',
  data() {
    return {
      activeTab: 'info',
      loading: false,
      contentId: null,
      lesson: {},
      
      showQaInput: false,
      newQuestion: '',
      sendingQa: false,

      userAnswers: {},
      submittingExam: false,
      modal: {
        show: false,
        title: '',
        message: '',
        isSuccess: true
      },

      showExamStartModal: false,
      examDuration: 0,
      examTimerString: '',
      timerInterval: null,
      isTimeUp: false
    }
  },
  mounted() {
    this.contentId = this.$route.params.id
    if (this.contentId) {
      this.fetchLessonDetails()
    }
  },
  beforeUnmount() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval)
    }
  },
  methods: {
    async fetchLessonDetails() {
      this.loading = true
      try {
        const userId = localStorage.getItem('user_id')
        const formData = createFormData({
          user_id: userId,
          content_id: this.contentId
        })

        const response = await apiClient.post('/lesson_content_details', formData)

        if (response.data.status === 'ok' && response.data.data) {
          this.lesson = response.data.data
          
          if (this.lesson.type === 'exam') {
            this.activeTab = 'exam'
            
            if (this.lesson.time && !this.lesson.has_passed_exam && this.lesson.can_take_exam !== false) {
               const timeVal = parseInt(this.lesson.time)
               if (!isNaN(timeVal) && timeVal > 0) {
                 this.examDuration = timeVal
                 this.showExamStartModal = true
               }
            }
          }
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    startExam() {
      this.showExamStartModal = false
      this.isTimeUp = false
      this.startTimer(this.examDuration * 60)
    },
    cancelExam() {
      this.$router.go(-1)
    },
    startTimer(durationSeconds) {
      let timer = durationSeconds
      this.updateTimerDisplay(timer)

      this.timerInterval = setInterval(() => {
        timer--
        this.updateTimerDisplay(timer)

        if (timer < 0) {
          clearInterval(this.timerInterval)
          this.isTimeUp = true
          this.examTimerString = '00:00'
        }
      }, 1000)
    },
    updateTimerDisplay(seconds) {
      const minutes = parseInt(seconds / 60, 10)
      const sec = parseInt(seconds % 60, 10)

      const m = minutes < 10 ? "0" + minutes : minutes
      const s = sec < 10 ? "0" + sec : sec

      this.examTimerString = m + ":" + s
    },
    async toggleBookmark() {
      try {
        const userId = localStorage.getItem('user_id')
        const formData = createFormData({
          user_id: userId,
          content_id: this.contentId
        })
        const response = await apiClient.post('/mark_content', formData)
        
        if (response.data.status === 'ok') {
          if (response.data.event && response.data.event.includes('unmarked')) {
            this.lesson.marked = false
          } else {
            this.lesson.marked = true
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
    async submitQuestion() {
      if (!this.newQuestion.trim()) return
      this.sendingQa = true
      try {
        const userId = localStorage.getItem('user_id')
        const formData = createFormData({
          user_id: userId,
          content_id: this.contentId,
          question: this.newQuestion
        })
        const response = await apiClient.post('/add_question_content', formData)
        if (response.data.status === 'ok') {
          this.newQuestion = ''
          this.showQaInput = false
          this.fetchLessonDetails() 
          this.notify(this.t('success_submit'), 'success')
        } else {
          this.notify(response.data.message || this.t('error_submit'), 'error')
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.sendingQa = false
      }
    },
    async submitExam() {
      if (this.isTimeUp) return;

      const lang = localStorage.getItem('app_lang')
      const isPashto = lang === 'ps'

      if (!this.lesson.can_take_exam) {
        this.modal = {
          show: true,
          title: this.t('attention'),
          message: this.t('exam_already_passed'),
          isSuccess: false
        }
        return
      }

      if (!this.lesson.exam || this.lesson.exam.length === 0) return

      const answersPayload = []
      for (const question of this.lesson.exam) {
        if (this.userAnswers[question.id]) {
          answersPayload.push({
            exams_id: question.id,
            answer: this.userAnswers[question.id]
          })
        }
      }

      if (answersPayload.length < this.lesson.exam.length) {
        if(!confirm(this.t('exam_incomplete'))) return
      }

      this.submittingExam = true
      try {
        const userId = localStorage.getItem('user_id')
        
        const rawBody = {
           apikey: '4f3d2a9b7c1e5d6f8a0b9c3d2e4f6a7b',
           debug: true,
           lang: localStorage.getItem('app_lang') || 'fa',
           user_id: userId,
           content_id: this.contentId,
           answers: answersPayload
        }
        
        const response = await apiClient.post('/take_exam', rawBody, {
           headers: { 'Content-Type': 'application/json' }
        })

        if (response.data.status === 'ok') {
           if(this.timerInterval) clearInterval(this.timerInterval);
           
           const result = response.data.data
           const score = result.score
           const totalScore = result.totalScore
           const isPassed = result.is_passed === 1 || result.is_passed === true

           this.userAnswers = {}

           if (isPassed) {
             this.modal = {
               show: true,
               title: isPashto ? 'تاسو بریالي شوئ' : 'آفرین بر تلاشتان',
               message: isPashto
                 ? `تاسو په بریالیتوب سره د ${totalScore} څخه ${score} نمره ترلاسه کړه`
                 : `شما با موفقیت نمره کامیابی ${score} از ${totalScore} گرفتید`,
               isSuccess: true
             }
           } else {
             this.modal = {
               show: true,
               title: isPashto ? 'له بده مرغه پوره نمره مو نه ده اخیستې' : 'متاسفانه نمره کافی نگرفتید',
               message: isPashto
                 ? `تاسو د ${totalScore} څخه ${score} نمره ترلاسه کړه`
                 : `شما نمره ${score} از ${totalScore} گرفتید`,
               isSuccess: false
             }
           }
           this.fetchLessonDetails()
        } else {
           this.notify(response.data.message || this.t('error_submit'), 'error')
        }

      } catch (error) {
        console.error(error)
        this.notify(this.t('communication_error'), 'error')
      } finally {
        this.submittingExam = false
      }
    },
    closeModal() {
      this.modal.show = false
    },
    isMp4(url) {
      if (!url) return false
      return url.toLowerCase().endsWith('.mp4') || url.includes('/storage/videos/')
    },
    getEmbedUrl(url) {
      if (!url) return ''
      if (url.includes('aparat.com/v/')) {
        try {
          const id = url.split('/v/')[1].split('/')[0]
          return `https://www.aparat.com/video/video/embed/videohash/${id}/vt/frame`
        } catch (e) {
          return url
        }
      }
      return url
    },
    downloadPdf(url) {
      if (!url) return;
      window.open(url, '_blank');
    }
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.line_height_2 {
  line-height: 2rem;
}
.bg_red {
  background-color: #FF5252;
}
.text_color_red {
  color: #FF5252;
}
.text_color_white {
  color: #ffffff;
}
.radio_circle {
  width: 20px;
  height: 20px;
  border: 2px solid #ccc;
  border-radius: 50%;
  position: relative;
}
.radio_circle.selected {
  border-color: #4A00E0;
}
.radio_circle.selected::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 10px;
  height: 10px;
  background-color: #4A00E0;
  border-radius: 50%;
}
.border_gray {
  border: 1px solid #eee;
}
.modal_overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal_content {
  background-color: white;
  width: 85%;
  max-width: 22rem;
  border-radius: 2.5rem;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
  animation: fadeIn 0.3s ease-out;
}
.icon_circle {
  border-radius: 50%;
  padding: 1rem;
  width: 6rem;
  height: 6rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -4rem;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  border: 4px solid white;
}
.modal_img {
  width: 3rem;
  height: 3rem;
}
.modal_btn {
  background: linear-gradient(90deg, #8E2DE2 0%, #4A00E0 100%);
  color: white;
  border: none;
  border-radius: 50px;
  padding: 0.8rem 0;
  font-weight: bold;
  font-size: 1rem;
  box-shadow: 0 5px 15px rgba(74, 0, 224, 0.4);
  cursor: pointer;
  width: 100%;
  transition: transform 0.2s;
}
.bg_red_btn {
  background: #FF5252 !important;
  box-shadow: 0 5px 15px rgba(255, 82, 82, 0.4) !important;
}
.bg_gray_btn {
  background: #9e9e9e !important;
  box-shadow: none !important;
}
.modal_btn:active {
  transform: scale(0.98);
}
@keyframes fadeIn {
  from { opacity: 0; transform: scale(0.9); }
  to { opacity: 1; transform: scale(1); }
}
</style>